/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An individual decision record for an approval request.
 */
export interface VmuaApprovalDecision { 
    /**
     * Unique ID of the decision record.
     */
    decisionId?: string;
    /**
     * The user who made the decision.
     */
    decidedBy?: string;
    /**
     * The decision made.
     */
    decision?: VmuaApprovalDecision.DecisionEnum;
    /**
     * Timestamp when the decision was recorded.
     */
    decidedAt?: Date;
}
export namespace VmuaApprovalDecision {
    export type DecisionEnum = 'APPROVE' | 'DENY';
    export const DecisionEnum = {
        APPROVE: 'APPROVE' as DecisionEnum,
        DENY: 'DENY' as DecisionEnum
    };
}


